<template>
    <div ref="remodal" class="remodal representative-example-modal" tabindex="-1" :data-remodal-id="this.remodalId" :id="remodalId" data-remodal-options="hashTracking: false, closeOnOutsideClick: false">
        <a data-remodal-action="close" class="remodal-close"></a>
        <div class="finance-result">
            <QuotePcp v-if="quoteType == financeKeys.PCP || quoteType == financeKeys.OVERAGE_PCP_ONLY" :loading="false" :quote="normalizedQuote" :rep-example="true" :vehicle="vehicle" :brand-p-c-p-finance-name="brandNewPCPFinanceName" />
            <QuotePsaPcpOnly v-else-if="quoteType == financeKeys.PSA_PCP_ONLY || quoteType == financeKeys.VAUXHALL_PCP_ONLY" :loading="false" :quote="normalizedQuote" :rep-example="true" />
            <QuoteDsgPcpOnly v-else-if="quoteType == financeKeys.DSG_PCP_ONLY" :loading="false" :quote="quote" :rep-example="true" />
            <QuoteHp v-else-if="quoteType == financeKeys.HP" :loading="false" :quote="normalizedQuote" :rep-example="true" />
        </div>

        <FinanceTerms v-if="vehicle" :vehicle="vehicle" :financeType="quoteType" :quoteValidFrom="quoteValidFrom" class="details-finance-terms terms" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FinanceTerms from './FinanceTerms.vue';
import QuotePcp from './Quotes/Quote-PCP.vue';
import QuotePsaPcpOnly from './Quotes/Quote-PSA_PCP_ONLY.vue';
import QuoteDsgPcpOnly from './Quotes/Quote-DSG_PCP_ONLY.vue';
import QuoteHp from './Quotes/Quote-HP.vue';
import { financeKeys } from '../../../modules/json/financeKeys';
import getFinanceNameFromKey from '../../api/finance/GetFinanceNameFromKey';
import normalizedQuote from '../../api/finance/NormalizeQuote';

import { format } from 'date-fns';

export default {
    components: {
        FinanceTerms,
        QuotePcp,
        QuotePsaPcpOnly,
        QuoteDsgPcpOnly,
        QuoteHp,
    },
    data() {
        return {
            financeKeys: financeKeys,
        };
    },
    computed: {
        ...mapState('FinanceParameters', {
            'personalQuote': 'modified'
        }),
        brandNewPCPFinanceName() {
            return getFinanceNameFromKey(this.vehicle, "PCP");
        },
        normalizedQuote() {
            return normalizedQuote(this.quote);
        },
        brandPCPFinanceName() {
            return getFinanceNameFromKey(this.vehicle, 'PSA_PCP_ONLY');
        },
        quoteType() {
            if (typeof this.quote.Key !== 'undefined') {
                return this.quote.Key;
            }
            return false;
        },
        vehicle() {
            return this.$store.state.RepresentativeExample.vehicle;
        },
        quote() {
            return this.$store.state.RepresentativeExample.quote;
        },
        lender() {
            if (!this.quote && this.quote !== 'loading') {
                return false;
            }
            if (typeof this.quote.Product == 'undefined' || typeof this.quote.Product.Lender == 'undefined') {
                return false;
            }
            return this.quote.Product.Lender;
        },
        quoteValidFrom() {
            return format(new Date(), 'Do MMMM YYYY');
        },
        shown() {
            return this.$store.state.RepresentativeExample.showModal;
        },
        open: {
            get() {
                return this.$store.state.RepresentativeExample.showModal;
            },
            set(val) {
                this.$store.commit('RepresentativeExample/setShowModal', val);
            }
        },
        remodalId() {
            return 'used-rep-example-' + this._uid;
        },
    },
    watch: {
        open: function(n,o) {
            if (!this.$refs.remodal) {
                console.error('no remodal instance');
            }
            let instance = $(this.$refs.remodal).remodal({
                hashTracking: false,
                closeOnOutsideClick: false
            });
            // Only open it if it's not already open
            let remodalState = instance.getState();
            if (n == true) {
                if (remodalState == 'closed' || remodalState == 'closing') {
                    instance.open();
                }
                return;
            }
            if (remodalState == 'open' || remodalState == 'opened' || remodalState == 'opening') {
                instance.close();
            }
            return;
        },
    },
    mounted() {
        $(document).on('closing', '#'+this.remodalId, (e) => {
            this.$store.commit('RepresentativeExample/setShowModal', false);
        });
        $(document).on('closed', '#'+this.remodalId, (e) => {
            this.$store.commit('RepresentativeExample/setShowModal', false);
        });
        $(document).on('opening', '#'+this.remodalId, (e) => {
            this.$store.commit('RepresentativeExample/setShowModal', true);
        });
        $(document).on('open', '#'+this.remodalId, (e) => {
            this.$store.commit('RepresentativeExample/setShowModal', true);
        });
    }
}
</script>
